<!--
 * @Author: guoyu
 * @Date: 2021-04-21 11:59:29
 * @LastEditors: your name
 * @LastEditTime: 2021-04-25 14:51:51
 * @Description: 由签约用户邀请注册,成功后红包
-->
<template>
  <div class="over-lay" v-show="dialogVisible&&couponList.length">
    <div class="invite-coupon">
      <div class="coupon-top"></div>
      <div
        class="coupon-bar"
        v-for="(couponInfo, index) in couponList"
        :key="index + 'c'"
      >
        <div class="coupon-left">
          <p>
            <span class="coupon-amount">{{ couponInfo.couponAmount }}</span>
            <span>弊</span>
          </p>
          <p class="coupon-start">滿{{ couponInfo.startAmount }}可用</p>
        </div>
        <div class="coupon-right">
          <p class="coupon-name">{{ couponInfo.couponName }}</p>
          <p class="coupon-deadline">
            <span>有效期至 </span>{{ new Date(couponInfo.deadlineTimestamp).$format('yyyy-MM-dd') }}
          </p>
        </div>
        <div class="coupon-count" v-if="couponInfo.count > 1">
          {{ couponInfo.count }}張
        </div>
      </div>
      <div class="footer-button">
        <NormalButton class="use-coupon" @click="useCoupon"
          >立即使用</NormalButton
        >
      </div>
      <div class="close-dialog el-icon-circle-close" @click="closeDialog"></div>
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/common/button/normal';
import { mapGetters } from 'vuex'
export default {
  components: {
    NormalButton
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
   computed: {
    ...mapGetters(['accountInfo']),
    couponList() {
      let list = this.accountInfo.couponInfoList || []
      list = list.sort((a, b)=>{
        return b.couponAmount - a.couponAmount
      })
      let types = {}
      const cc =  list.reduce((pre, item)=>{
         let couponType = item.couponTemplate
         if(!types[couponType]) {
           types[couponType] = { index: pre.length , count: 0}
           pre.push(item)
         }
         let currentType = types[couponType]
         currentType.count++
         pre[currentType.index].count = currentType.count
         return pre
      }, [])
      return cc
    }
  },
  methods: {
    useCoupon() {
      this.dialogVisible = false;
      this.$emit('useCoupon');
    },
    closeDialog() {
       this.dialogVisible = false;
       this.$router.replace({
           path: '/'
       })
       this.$emit('close')
    }
  }
};
</script>
<style lang="scss" scoped>
.over-lay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.invite-coupon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 289px;
  height: 476px;
  background: #df3a34;
  border-radius: 16px;
}
.coupon-top {
  width: 289px;
  height: 140px;
  margin-bottom: 16px;
  background: url(./images/invite-coupon.png) no-repeat;
  background-size: 100% 100%;
}
.coupon-bar {
  position: relative;
  display: flex;
  width: 263px;
  height: 72px;
  margin: 0 auto 8px;
  overflow: hidden;
  background: #ffffff;
  border-radius: 6px;
}
.coupon-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 97px;
  height: 72px;
  font-size: 12px;
  color: #ed7433;
  background: #fcf6e4;
}
.coupon-amount {
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
}
.coupon-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 12px 0;
  font-size: 12px;
  line-height: 16px;
  color: #999999;
}
.coupon-name {
  margin-bottom: 2px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.coupon-count {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 20px;
  top: 0;
  right: 0;
  border-radius: 0 0 0 6px;
  font-size: 12px;
  background: #ffdd1e;
  color: #6b211e;
}
.footer-button {
  text-align: center;
}
.use-coupon {
  width: 158px;
  height: 40px;
  margin: 24px auto 24px;
}
.close-dialog {
  position: absolute;
  bottom: -33px;
  transform: translateY(100%);
  width: 100%;
  text-align: center;
  font-size: 29px;
  color: #ffffff;
}
</style>
